var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "google-pay-method" }, [
    _vm.price
      ? _c(
          "div",
          {
            staticClass: "method",
            class: { noClick: _vm.loadingShow },
            on: { click: _vm.handleGooglePay },
          },
          [
            _c("div", { staticClass: "methods" }, [
              _c("div", { staticClass: "method-img" }, [
                _vm.isIOS()
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/common/apple_pay.png"),
                        alt: "",
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/packageAssets/common/google.png"),
                        alt: "",
                      },
                    }),
              ]),
              _c("div", { staticClass: "line" }),
              _c("div", { staticClass: "method-name" }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.isIOS() ? "Apple Pay" : "Google Pay")),
                ]),
                _c("div", { staticClass: "rate" }, [
                  _c("div", { staticClass: "pay-price" }, [
                    _c("i", [_vm._v(_vm._s(_vm.currency))]),
                    _c("span", [_vm._v(_vm._s(_vm.price))]),
                  ]),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }